/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Notificationcenter_Triggerarialabel3Inputs */

const en_notificationcenter_triggerarialabel3 = /** @type {(inputs: Notificationcenter_Triggerarialabel3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Notifications`)
};

/**
* | output |
* | --- |
* | "Notifications" |
*
* @param {Notificationcenter_Triggerarialabel3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const notificationcenter_triggerarialabel3 = /** @type {((inputs?: Notificationcenter_Triggerarialabel3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Notificationcenter_Triggerarialabel3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_notificationcenter_triggerarialabel3(inputs)
});
export { notificationcenter_triggerarialabel3 as "notificationCenter_triggerAriaLabel" }